import React from 'react'
import { RemixiconReactIconComponentType } from 'remixicon-react';
import ShieldCrossFillIcon from 'remixicon-react/ShieldCheckFillIcon';
import Shield from './Shield.png'
import Image from 'next/image';
import { useWindowWidth } from '@prishapolicy/shared/ui';

interface KeyBenifitsCardProps {
    title: string;
    description: string;
    icon?: RemixiconReactIconComponentType | undefined
    isLast?: boolean;
}

export const KeyBenifits = ({ KeyBenifitsData }: {
    KeyBenifitsData: KeyBenifitsCardProps[]
}) => {
    const { isXl } = useWindowWidth();
    return (
        <div className='bg-surface-green rounded-[20px] flex justify-between gap-7 w-full'>
            <div className='pl-[50px] py-[50px] pr-[50px] xl:pr-0 flex flex-col  gap-15'>
                <h1 className='text-title-4 font-bold '>Key Benefits</h1>
                <div className='grid grid-cols-1 xl:grid-cols-2 gap-10'>

                    {KeyBenifitsData.slice(0, 4).map((benefit, idx) =>
                        <KeyBenifitsCard title={benefit.title} description={benefit.description} icon={benefit.icon} key={idx} />
                    )}
                    <div className='xl:col-span-2'>
                        <KeyBenifitsCard title={KeyBenifitsData[4].title} isLast={true} description={KeyBenifitsData[4].description} icon={KeyBenifitsData[4].icon} />
                    </div>
                </div>
            </div>
            {isXl && <div className='justify-center items-center flex'>
                <Image src={Shield} alt='Surety Bond' className='w-full h-[600px] object-contain' />
            </div>}
        </div>
    )
}


export const KeyBenifitsCardData: KeyBenifitsCardProps[] = [
    {
        title: 'Financial Protection',
        description: "Surety bonds guarantee that the contracted work will be completed as per the terms of the agreement.",
        icon: ShieldCrossFillIcon
    },
    {
        title: 'Assurance of Quality and Completion',
        description: "Surety bonds provide assurance that projects will be completed according to specified terms and quality standards",
        icon: ShieldCrossFillIcon
    },
    {
        title: 'Legal Compliance',
        description: "Certain industries and government entities require contractors to obtain surety bonds as part of their licensing or regulatory compliance.",
        icon: ShieldCrossFillIcon
    },
    {
        title: 'Risk Management',
        description: "They play a crucial role in risk management by enhancing the credibility of contractors and demonstrating their financial stability.",
        icon: ShieldCrossFillIcon
    },
    {
        title: 'Financial Guarantees for Subcontractors and Suppliers',
        description: "Surety bond, specifically guarantee that subcontractors and suppliers will be paid for their services and materials. This ensures that everyone involved in the project is compensated, maintaining trust and smooth project progression. ",
        icon: ShieldCrossFillIcon
    },

]

export const KeyBenifitsCard = ({ title, description, icon, isLast }: KeyBenifitsCardProps) => {
    const IconElement = icon as RemixiconReactIconComponentType;
    return (
        <div className='flex flex-col sm:flex-row gap-5 sm:gap-10 '>

            <div className='bg-green-700 p-3 flex justify-center items-center rounded-lg top-0 w-12 max-h-12'>
                <IconElement className='text-white w-6 h-6 ite' />
            </div>
            <div className='flex flex-col  gap-2'>
                <h1 className='text-title-6 font-bold flex items-center'>{title}</h1>
                <p className={`text-title-7 font-normal  ${isLast ? "w-full xl:w-[800px]" : "w-full xl:w-[358px]"}`}>{description}</p>
            </div>
        </div>
    )
}
